import { type FC } from 'react'
import { CheckoutProgressBar, type Step } from './CheckoutProgress'

interface PageProps {
  progressBarStep: Step
  skinny?: boolean
  withQurbani?: boolean
}

// This component is used for pages in the checkout flow
// It includes the progress bar
export const PageForCheckoutFlow: FC<PageProps> = ({ progressBarStep, skinny = false, withQurbani = false, children }) => {
  return <>
        <div className="p-4 md:py-10 flex-1 w-full gap-y-4 flex flex-col items-center bg-mtd-bg">
            {/* TODO: update to mtd version */}
            <div className="max-w-fg-screen-small w-full pb-2">
                <CheckoutProgressBar step={progressBarStep} withQurbani={withQurbani} />
            </div>
            <div className={` ${skinny ? 'max-w-fg-screen-small' : 'max-w-fg-page'} flex-1 flex flex-col w-full`}>
            {children}
            </div>
        </div>
    </>
}
